import React from "react";
import { SidebarLink } from "./styles";
import painel from "../../assets/iconsMenu/icon-rocket.svg";
import lupa from "../../assets/iconsMenu/icon-search.svg";
import userIcom from "../../assets/icon-avatar.svg";
import iconBook from "../../assets/iconsMenu/icon-book.svg";
import iconPhone from "../../assets/iconsMenu/icon-help.svg";

import "./listItems.css";
import { useLocation } from "react-router-dom";

export const MainListItems = () => {
  const { pathname } = useLocation();

  return (
    <div className="containerMenuCompanies">
      <SidebarLink to={"/companies/panel"}>
        <div
          className={
            pathname === "/companies/panel" ? "itemLinkSelected" : "itemLink"
          }
        >
          <img src={painel} alt="icon" />
        </div>
      </SidebarLink>

      <SidebarLink to={"/companies/talents"}>
        <div
          className={
            pathname === "/companies/talents" ? "itemLinkSelected" : "itemLink"
          }
        >
          <img src={lupa} alt="icon" />
        </div>
      </SidebarLink>

      <SidebarLink to={"/companies/settings"}>
        <div
          className={
            pathname === "/companies/settings" ? "itemLinkSelected" : "itemLink"
          }
        >
          <img src={userIcom} alt="icon" />
        </div>
      </SidebarLink>

      {/* <SidebarLink to={"/companies/finance"}>
        <div
          className={
            pathname === "/companies/finance" ? "itemLinkSelected" : "itemLink"
          }
        >
          <img src={iconBook} alt="icon" />
        </div>
      </SidebarLink>

      <SidebarLink to={"/companies/finance"}>
        <div
          className={
            pathname === "/companies/finance" ? "itemLinkSelected" : "itemLink"
          }
        >
          <img src={iconPhone} alt="icon" />
        </div>
      </SidebarLink> */}
    </div>
  );
};
